import { ManageAccounts, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { useState } from 'react';
import {
    Button,
    Modal,
    Box,
    CircularProgress,
    Typography,
    Grid,
    Autocomplete,
    Select,
    MenuItem,
    Checkbox,
    TextField,
    FormControl
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { successAlert } from 'ui-component/Toasts';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdateShopPurchase = ({ shopPurchaseList, fetchShopPurchase, statusList }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [quantity, setQuantity] = useState(shopPurchaseList.quantity ? shopPurchaseList.quantity : '');
    const [totalPrice, setTotalPrice] = useState(shopPurchaseList.totalPrice ? shopPurchaseList.totalPrice : '');
    const [address, setAddress] = useState(shopPurchaseList.address ? shopPurchaseList.address : '');
    const [status, setStatus] = useState(shopPurchaseList.statusName ? shopPurchaseList.statusName : '');

    console.log('Testing', statusList);

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [updateshopPurchaseListLoading, setUpdateshopPurchaseListLoading] = useState(false);

    const submitInsertTasklist = async () => {
        setUpdateBtnDisabled(true);
        setTimeout(() => {
            setUpdateBtnDisabled(false);
        }, 3000);
        setUpdateshopPurchaseListLoading(true);
        try {
            const res = await axiosInstance.put(
                '/CustomerPurchasedItem',
                {
                    id: shopPurchaseList.id,
                    quantity: quantity,
                    totalPrice: totalPrice,
                    address: address,
                    statusID: status
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Shop Purchase Updated successfully.');
                fetchShopPurchase();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateshopPurchaseListLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ManageAccounts />
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {updateshopPurchaseListLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Drivers
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Quantity :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Total Price
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={totalPrice}
                                            onChange={(e) => setTotalPrice(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Address
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Status :
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Select
                                                displayEmpty
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem value="">Select Status</MenuItem>
                                                {statusList.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => submitInsertTasklist()}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default UpdateShopPurchase;
